import { create } from "zustand";
import { SymbolsWatchlistStore } from "./types";
import { 
  saveWatchlistToStorage, 
  loadWatchlistFromStorage 
} from "./storage";
import { DEFAULT_WATCHLIST_SYMBOLS, MAX_WATCHLIST_SYMBOLS } from "./default-data";

export const useSymbolsWatchlistStore = create<SymbolsWatchlistStore>((set, get) => ({
  watchlist: DEFAULT_WATCHLIST_SYMBOLS,

  addSymbol: (symbol: string) => {
    const currentWatchlist = get().watchlist;
    
    // Check if symbol already exists
    if (currentWatchlist.includes(symbol)) {
      console.warn(`Symbol ${symbol} is already in watchlist`);
      return;
    }

    // Check max limit
    if (currentWatchlist.length >= MAX_WATCHLIST_SYMBOLS) {
      console.warn(`Watchlist is full. Maximum ${MAX_WATCHLIST_SYMBOLS} symbols allowed.`);
      return;
    }

    const newWatchlist = [...currentWatchlist, symbol];
    set({ watchlist: newWatchlist });
    saveWatchlistToStorage(newWatchlist);
  },

  removeSymbol: (symbol: string) => {
    const newWatchlist = get().watchlist.filter(s => s !== symbol);
    set({ watchlist: newWatchlist });
    saveWatchlistToStorage(newWatchlist);
  },

  setWatchlist: (symbols: string[]) => {
    // Remove duplicates and limit to max symbols
    const uniqueSymbols = Array.from(new Set(symbols)).slice(0, MAX_WATCHLIST_SYMBOLS);
    set({ watchlist: uniqueSymbols });
    saveWatchlistToStorage(uniqueSymbols);
  },

  clearWatchlist: () => {
    set({ watchlist: [] });
    saveWatchlistToStorage([]);
  },

  isSymbolInWatchlist: (symbol: string) => {
    return get().watchlist.includes(symbol);
  },

  loadWatchlist: () => {
    const savedWatchlist = loadWatchlistFromStorage();
    set({ watchlist: savedWatchlist });
  }
}));
